import { type SxProps, type Theme } from "@mui/material/styles";

import { LINK_FOCUS_RADIUS, LINK_UNDERLINE_OFFSET } from "ui/link/link.constants";
import { type LinkSize } from "ui/link/link.types";

/**
 * Per size: the focus ring's corner, which follows the box's, and Figma's underline, which sits on the
 * last pixel row of the line box rather than where the font would put it.
 */
export const LINK_SIZE_SX: Record<LinkSize, SxProps<Theme>> = {
  small: (theme) => ({
    borderRadius: `${theme.shape[LINK_FOCUS_RADIUS.small]}px`,
    textUnderlineOffset: `${LINK_UNDERLINE_OFFSET.small}px`,
  }),
  medium: (theme) => ({
    borderRadius: `${theme.shape[LINK_FOCUS_RADIUS.medium]}px`,
    textUnderlineOffset: `${LINK_UNDERLINE_OFFSET.medium}px`,
  }),
};
